module.exports = __webpack_public_path__ + "img/pg.pgeb9cc6c.svg";